import React, {useEffect} from 'react'
import './index.css';
import { NavLink } from "react-router-dom";
import img1 from "./images/4.jpg"
import img2 from "./images/7.jpg"
import img3 from "./images/8.jpg"
import img4 from "./images/9.jpg"
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import Aos from "aos"
import "aos/dist/aos.css"
// import Tooltip from '@material-ui/core/Tooltip';
const Home = () => {
    useEffect(() => {
        Aos.init({duration:1200});
    },[])

    return (
        <div>
            <header className='header'>
                <div className='header-content'>
                    <h1 className='lg-heading text-light'>Get Ready To Burn</h1>
                    <p className='text-light'>Get Fit, Strong & Motivated!</p>
                    <p className='text-light'>TAKE YOUR TRAINING TO THE NEXT LEVEL</p>
                    <a href="#explore-places" className='btn btn-primary  md-heading'>Explore More</a>
                </div>
            </header>

            <section className='showcase showcase1' id='explore-places'>
                <div className='container'>
                    <div data-aos="flip-left" className='rowhome row1'>
                        <div className='img-box'>
                            <img src={img1} alt="Image Description" />
                        </div>
                        <div className='text-box'>
                            <h2 className='lg-heading text-black'>Cardio Training</h2>
                            <p className='text-gray small-heading'>Whether you want increased energy or reduced stress, cardio training helps you live a fitter life while strengthening your heart and lungs. From interval workouts to endurance exercises, cardio training can also help to lower blood pressure and cholesterol levels..</p>
                            <a href='#explore_more_places' className='btn btn-secondry'>more</a>
                        </div>
                    </div>
                    <div className='rowhome row2'>
                        <div data-aos="fade-left" className='img-box'>
                            <img src={img2} alt="Image Description" />
                        </div>
                        <div data-aos="fade-right" className='text-box'>
                            <h2 className='lg-heading text-black'>Build Strength</h2>
                            <p className='text-gray small-heading'>Shape your body and burn fat with strength training.With the right equipment such as free weights or resistance machines and advice from our experts, you can improve your overall health while increasing muscle and bone strength.</p>
                            <a href='#explore_more_places' className='btn btn-secondry'>more</a>
                        </div>
                    </div>
                </div>
            </section>
            <section className='showcase showcase2' id='explore_more_places'>
                <div className='container'>
                    <div className='rowhome row1'>
                        <div data-aos="fade-right" className='img-box'>
                            <img src={img3} alt="Image Description" />
                        </div>
                        <div data-aos="fade-left" className='text-box'>
                            <h2 className='lg-heading text-black'>Physio Training</h2>
                            <p className='text-gray small-heading'>Tailored specifically around your individual fitness, one-to-one personal training ensures you get the most out of every workout. Our expert personal trainers can offer support, advice and motivation to keep you on the right track.</p>
                            <NavLink exact to="./about" className='btn btn-secondry'>more</NavLink>
                        </div>
                    </div>
                    <div data-aos="flip-right" className='rowhome row2'>
                        <div className='img-box'>
                            <img src={img4} alt="Image Description" />
                        </div>
                        <div className='text-box'>
                            <h2 className='lg-heading text-black'>Advanvce Gym</h2>
                            <p className='text-gray small-heading'>
                                 A high-performance training facility that offers a wide variety of programs for athletes of all ages, for fitness enthusiasts and for individuals who are looking to make a serious commitment to their long-term health and want assistance to reach their own individual fitness goals.</p>
                            <NavLink exact to="./about" className='btn btn-secondry'>more</NavLink>
                        </div>
                    </div>
                </div>
            </section>
            <section className="features">
                <div className="container">
                    <div className='box-wrapper'>
                        <div data-aos="fade-down" className='box box1'>
                            <AccessibilityIcon fontSize="large" />
                            <h2 className='md-heading'>PROGRESSION</h2>
                            <p className='small-heading'>The last three or four reps is what makes the muscle grow. This area of pain divides a champion from someone who is not a champion.</p>
                        </div>
                        <div data-aos="fade-up" className='box box2'>
                            <FitnessCenterIcon fontSize="large" />
                            <h2 className='md-heading'>WORKOUT</h2>
                            <p className='small-heading'>If you think lifting is dangerous, try being weak. Being weak is dangerous.What hurts today makes you stronger tomorrow.</p>
                        </div>
                        <div data-aos="fade-down" className='box box3'>
                            <RestaurantIcon fontSize="large" />
                            <h2 className='md-heading'>NUTRITION</h2>
                            <p className='small-heading'>Being fit is 80% diet and 20% exercise.A healthy diet is a solution to many of our health-care problems. It’s the most important solution.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home;